// extracted by mini-css-extract-plugin
export default {"scrollableContainer":"ScrollableContainer_scrollableContainer__bq84e"};